import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { CustomPlpState } from '../store';

@Injectable({
  providedIn: 'root'
})

export class CustomPlpService {
  sortedIds;

  public buildQueryParams(config: CustomPlpState): {
    filter: Params
  } {
    /*
     * orderIds
     * for now we considering max sorted ids are few 10-15 discussion
     * on solving this with other options like post call in progress
     **/
    const filterObj: any = {
      filter: {}
    };
    if (!config.slug) {
      filterObj.filter.hasPromotion = true;
    } else {
      if (config.filters.isHasPromotion) {
        filterObj.filter.promotion = true;
      }
      if (!!config.filters.promoTag) {
        filterObj.filter.promoTag = config.filters.promoTag;
      }
      //TODO check categories and change it to category api
      if (
        config.filters.categoryIds &&
        config.filters.categoryIds.length > 0
      ) {
        config.filters.categoryIds.forEach((item, index) => {
          filterObj.filter[`categories.${index}`] = item;
        });
      }
    }
    return filterObj;
  }

  public setSortedIds(config) {
    this.sortedIds = config.sortedIds;
  }

  public get getSortedIds() {
    return this.sortedIds;
  }
}
